export const skillsData = [
    {
      label: "FRONTEND",
      data: [
        {
          skillName: "HTML",
          percentage: "90",
        },
        {
          skillName: "CSS",
          percentage: "70",
        },
        {
          skillName: "Javascript",
          percentage: "80",
        },
        {
          skillName: "React.js",
          percentage: "50",
        },
      ],
    },
    {
      label: "BACKEND",
      data: [
        {
          skillName: "Node.js",
          percentage: "50",
        },
        {
          skillName: "Express.js",
          percentage: "50",
        },
      ],
    },
    {
      label: "DATABASES",
      data: [
        {
          skillName: "MySQL",
          percentage: "70",
        },
        {
          skillName: "MONGO DB",
          percentage: "50",
        },
      ],
    },
  ];
  